export enum BookingReportType {
  ByWeek = "ByWeek",
  ByOrganization = "ByOrganization",
  ByHospital = "ByHospital",
  ByDepartment = "ByDepartment",
  ByUser = "ByUser",
  ByConsultant = "ByConsultant",
  ByProject = "ByProject"
}
